import { render, staticRenderFns } from "./MWSpringPoster.vue?vue&type=template&id=3ca6a46b&scoped=true"
import script from "./MWSpringPoster.vue?vue&type=script&lang=js"
export * from "./MWSpringPoster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca6a46b",
  null
  
)

export default component.exports